<template>
  <img class="divider-img" src="@/assets/member/heng.png">
</template>

<script>
export default {
  name: 'DividerImg',
}
</script>

<style lang="less" scoped>
  .divider-img {
    width: 100%;
    height: 40px;
    margin: 10px 0 30px 0;
    object-fit: contain;
  }

</style>
